  /* Automatischer Durchlauf der Trust-Items (nur Mobil, Muster aus alb-custom-info):
     Sequenz einmal klonen -> nahtloser Loop, rAF-Scroll mit px/s, Pause bei Wischen/Wheel
     (Neustart nach 4 s Ruhe), stoppt offscreen, respektiert prefers-reduced-motion. */
  (() => {
    'use strict';
    if (!window.albTiAutoplayInit) {
      const MOBIL = matchMedia('(max-width: 749px)');
      const RUHIG = matchMedia('(prefers-reduced-motion: reduce)');
      /* Kachelweise weiterschalten (Moritz 2026-09-14): alle N Sekunden zur nächsten Kachel scrollen
         (smooth + scroll-snap center), am Ende zurück zur ersten; Wischen/Wheel pausiert 4 s;
         nur mobil, nur sichtbar, respektiert prefers-reduced-motion. Keine Klone nötig. */
      window.albTiStepInit = (grid) => {
        if (grid.dataset.albInit) return;
        grid.dataset.albInit = '1';
        const intervall = Math.max(1, parseFloat(grid.dataset.albStepInterval) || 3) * 1000;
        const items = () => Array.from(grid.children).filter((el) => el.offsetWidth > 0);
        let timer = 0, idleTimer = 0, sichtbar = false, aktiv = false;
        const mitte = (el) => el.offsetLeft - (grid.clientWidth - el.offsetWidth) / 2;
        const aktuell = () => {
          const list = items(); if (!list.length) return 0;
          const x = grid.scrollLeft; let best = 0, dist = Infinity;
          list.forEach((el, i) => { const d = Math.abs(mitte(el) - x); if (d < dist) { dist = d; best = i; } });
          return best;
        };
        const schritt = () => {
          const list = items(); if (list.length < 2) return;
          const next = (aktuell() + 1) % list.length;
          grid.scrollTo({ left: Math.max(0, mitte(list[next])), behavior: 'smooth' });
        };
        grid.albStep = schritt;
        const start = () => {
          if (aktiv || !sichtbar || !MOBIL.matches || RUHIG.matches) return;
          if (grid.scrollWidth <= grid.clientWidth + 1) return;
          aktiv = true; timer = setInterval(schritt, intervall);
        };
        const stopp = () => { aktiv = false; clearInterval(timer); };
        const pause = () => { stopp(); clearTimeout(idleTimer); idleTimer = setTimeout(start, 4000); };
        ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => grid.addEventListener(ev, pause, { passive: true }));
        new IntersectionObserver((eintraege) => { sichtbar = eintraege.some((e) => e.isIntersecting); if (sichtbar) start(); else stopp(); }).observe(grid);
        MOBIL.addEventListener('change', () => { if (MOBIL.matches) start(); else stopp(); });
        RUHIG.addEventListener('change', () => { if (RUHIG.matches) stopp(); else start(); });
      };
      window.albTiAutoplayInit = (grid) => {
        if (grid.dataset.albAutoplayMode === 'step') return window.albTiStepInit(grid);
        if (grid.dataset.albInit) return;
        grid.dataset.albInit = '1';
        const tempo = parseFloat(grid.dataset.albAutoplaySpeed) || 30;
        const originale = Array.from(grid.children);
        if (originale.length < 2) return;
        /* Klone (Loop-Puffer) erst anlegen, wenn der Scroller mobil wirklich läuft –
           auf Desktop blieben sie sonst als doppelte Items sichtbar (Editor/Grid). */
        let ersterKlon = null;
        const klonen = () => {
          if (ersterKlon) return;
          const frag = document.createDocumentFragment();
          originale.forEach((el) => {
            const klon = el.cloneNode(true);
            klon.setAttribute('aria-hidden', 'true');
            klon.setAttribute('data-alb-ti-klon', '');
            klon.removeAttribute('id');
            klon.removeAttribute('data-shopify-editor-block');
            klon.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
            klon.querySelectorAll('a, [tabindex]').forEach((n) => n.setAttribute('tabindex', '-1'));
            frag.appendChild(klon);
          });
          grid.appendChild(frag);
          ersterKlon = grid.children[originale.length];
        };
        let pos = 0, vorher = 0, rafId = 0, idleTimer = 0, aktiv = false, sichtbar = false;
        const frame = (t) => {
          if (!aktiv) return;
          if (vorher) {
            pos += tempo * Math.min((t - vorher) / 1000, 0.1);
            const periode = ersterKlon.offsetLeft - originale[0].offsetLeft;
            if (periode > 0 && pos >= periode) pos -= periode;
            grid.scrollLeft = pos;
          }
          vorher = t;
          rafId = requestAnimationFrame(frame);
        };
        const start = () => {
          if (aktiv || !sichtbar || !MOBIL.matches || RUHIG.matches) return;
          if (grid.scrollWidth <= grid.clientWidth + 1) return;
          klonen();
          aktiv = true;
          grid.classList.add('alb-ti-autoplay');
          pos = grid.scrollLeft;
          vorher = 0;
          rafId = requestAnimationFrame(frame);
        };
        const stopp = () => { aktiv = false; cancelAnimationFrame(rafId); grid.classList.remove('alb-ti-autoplay'); };
        const pause = () => { stopp(); clearTimeout(idleTimer); idleTimer = setTimeout(start, 4000); };
        ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => grid.addEventListener(ev, pause, { passive: true }));
        grid.addEventListener('scroll', () => { if (!aktiv) pause(); }, { passive: true });
        new IntersectionObserver((eintraege) => { sichtbar = eintraege.some((e) => e.isIntersecting); if (sichtbar) start(); else stopp(); }).observe(grid);
        MOBIL.addEventListener('change', () => { if (MOBIL.matches) start(); else stopp(); });
        RUHIG.addEventListener('change', () => { if (RUHIG.matches) stopp(); else start(); });
      };
      document.addEventListener('shopify:section:load', (e) => {
        e.target.querySelectorAll('.alb-ti-grid[data-alb-autoplay]').forEach(window.albTiAutoplayInit);
      });
    }
    document.querySelectorAll('.alb-ti-grid[data-alb-autoplay]').forEach(window.albTiAutoplayInit);
  })();
